/**
 * Attachment answers, shared by the exam view modes, the vendored essay
 * question and the assignment unit. A leaf module (no imports) so it stays
 * unit-testable without the component library.
 *
 * A stored attachment answer is a JSON string array of platform file URLs.
 */

/** Never throws; always returns a FRESH array (the package attachment list splices the array it is given). */
export function parseAttachmentAnswer(value: unknown): string[] {
	if (typeof value !== 'string' || value === '') return []
	let parsed: unknown
	try {
		parsed = JSON.parse(value)
	} catch {
		return []
	}
	if (!Array.isArray(parsed)) return []
	return parsed.filter((entry): entry is string => typeof entry === 'string')
}

/** `[]` is not an answer: the API stores a cleared attachment answer as null. */
export function serializeAttachmentAnswer(urls: string[]): string | null {
	return urls.length ? JSON.stringify(urls) : null
}

/** Exactly what the API's upload validator accepts (jpg jpeg png gif webp pdf). */
export const ANSWER_ATTACHMENT_ACCEPT = '.pdf,.png,.jpg,.jpeg,.gif,.webp'
const ANSWER_ATTACHMENT_MIME = /^(application\/pdf|image\/(png|jpeg|gif|webp))$/i
export const isAllowedAnswerFile = (file: File): boolean => ANSWER_ATTACHMENT_MIME.test(file.type)
